import React, { useState, useEffect } from "react";
import { Checkbox } from "antd";

const ColumnPicker = ({
  columns,
  hiddenColumns,
  selectedColumns,
  onChange,
  emptyColumnName,
  disabledColumns
}) => {
  const OPTIONS = columns.map((col) => ({
    label: col.title || col.dataIndex || emptyColumnName,
    value: col.dataIndex || col.title,
  }));

  const initialCheckedList = selectedColumns.length > 0 
    ? selectedColumns 
    : OPTIONS.map(option => option.value)
      .filter(value => !hiddenColumns.includes(value));

  const [checkedList, setCheckedList] = useState(initialCheckedList);

  useEffect(() => {
    setCheckedList(initialCheckedList);
  }, [selectedColumns, hiddenColumns, columns]);

  const handleCheckboxChange = (value) => {
    const updatedCheckedList = checkedList.includes(value)
      ? checkedList.filter((item) => item !== value)
      : [...checkedList, value];

    setCheckedList(updatedCheckedList);
    if (onChange) {
      onChange(updatedCheckedList);
    }
  };

  return (
    <div className="tbl-col-picker">
      {OPTIONS.map(option => (
        <div key={option.value} className="column-picker-item">
          <Checkbox
            checked={checkedList.includes(option.value)}
            onChange={() => handleCheckboxChange(option.value)}
            disabled={disabledColumns?.includes(option.label)}
          >
            {option.label}
          </Checkbox>
        </div>
      ))}
    </div>
  );
};

export default ColumnPicker;
